<template>
  <v-card-text>
    <v-form ref="geneTestform" v-model="formValid">
      <v-radio-group v-model="dataModel[modifyIndex].isgeneTest">
        <v-radio v-for="n in geneTestList" :key="n" :label="`${n}`" :value="n"></v-radio>
      </v-radio-group>
      <template v-if="dataModel[modifyIndex].isgeneTest !== 'No'">
        <v-text-field
        v-if="dataModel[modifyIndex].isgeneTest !== 'Yes, testing was negative.'"
          v-model="dataModel[modifyIndex].geneTestDetail.geneName"
          label="Whats the name of the Gene"

          value

        ></v-text-field>
        <v-text-field
        v-if="dataModel[modifyIndex].isgeneTest !== 'Yes, testing was negative.'"
          v-model="dataModel[modifyIndex].geneTestDetail.mutationName"
          label="Whats the name of the Mutation"
          value
        ></v-text-field>
        <v-text-field
          v-model="dataModel[modifyIndex].geneTestDetail.testName"
          label="Whats the name of the Test"

          value
        ></v-text-field>
        <v-select
          v-model="dataModel[modifyIndex].geneTestDetail.labName"
          :items="labList"

          label="select the name of the lab"
        ></v-select>
        
        <v-text-field
          v-if="dataModel[modifyIndex].geneTestDetail.labName === 'Other'"
          v-model="dataModel[modifyIndex].geneTestDetail.labNameOther"
          label="Whats the name of the lab"
          :rules="fieldRules"
          value
        ></v-text-field>
      </template>

    </v-form>
  </v-card-text>
</template>

<script>
import { mapFields } from "vuex-map-fields";
export default {
  props: {
    modifyIndex: Number
  },
  data: () => ({
    fieldRules: [v => !!v || "this field is required"],
    geneTestList: [
      "No",
      "Yes, testing was negative.",
      "Yes, testing was positive."
    ],
    labList: ["Ambry", "Myriad", "Invitae", "Color", "GeneDx", "Quest", "Other"]
  }),
  computed: {
    ...mapFields("patientQuestion", ["dataModel", "formValid"])
  }
};
</script>
